import { Component, OnInit } from '@angular/core';
import { SettingService } from "../../services/setting.service";

@Component({
  selector: 'app-maintenance-banner',
  templateUrl: './maintenance-banner.component.html',
  styleUrls: ['./maintenance-banner.component.scss']
})
export class MaintenanceBannerComponent implements OnInit {

  banners : any;

  constructor(private settingService: SettingService) { }

  ngOnInit(): void {
    let selectedVersion = 5;
    this.settingService.getGlobalSettings(selectedVersion).then((settings) => {
      let banners = this.getBanner(settings);
      if(!!banners) this.banners = banners.split('|');
    });
  }

  getBanner(settings: any) {
    let data = settings.filter((banner: any) => {
      if (banner.name == 'maintenance-banner-admin') {
        return banner.value;
      }

    });
    let [bannerTitle] = data;
    return bannerTitle.value;
  }
}
